import { MealTime } from "@/clients/models/MealTime";
import FilledButton from "@/components/button/filled-button";
import { PageContainer } from "@/components/container/page-container";
import { SearchInput } from "@/components/form/search-input";
import { useGetMealPreferenceSuggestions } from "@/hooks/requests/meal-preference/use-get-suggestions";
import { IonModal, IonSpinner } from "@ionic/react";
import { useRef } from "react";
import { ResultGroup } from "./result-group";

interface AddFoodPageProps {
  mealTime: MealTime;
  selectedFoodSet: Set<string>;
  onAddFood: (food: string) => void;
}

const AddFoodSearchBar = ({
  onAddFood,
  mealTime,
  selectedFoodSet,
}: AddFoodPageProps) => {
  const searchValueRef = useRef<string>("");
  const modalRef = useRef<HTMLIonModalElement>(null);
  const { suggestionOptions, isLoading } =
    useGetMealPreferenceSuggestions(mealTime);

  function onShowAddFoodModal() {
    modalRef.current?.present();
  }

  // function onWillDismiss(event: CustomEvent<OverlayEventDetail>) {
  //   if (event.detail.role === "confirm") {
  //     onAddFood(event.detail.data);
  //   }
  // }

  function onClose() {
    modalRef.current?.dismiss();
  }

  const onAdd = (food: string) => {
    modalRef.current?.dismiss(food, "confirm");
    onAddFood(food);
  };

  return (
    <>
      <SearchInput
        id="date-picker-search-input"
        placeholder="Search..."
        onClick={onShowAddFoodModal}
      />
      <IonModal
        ref={modalRef}
        trigger="date-picker-search-input"
        className="h-full"
        onDidDismiss={onClose}
      >
        <PageContainer onBack={onClose}>
          <div className="w-full flex gap-4">
            <SearchInput
              placeholder="Please enter a food name"
              onBlur={(value) => {
                searchValueRef.current = value;
              }}
            />
            <FilledButton
              text="Add"
              color="dark"
              className="rounded-md!"
              onClick={() => {
                onAdd(searchValueRef.current);
              }}
            />
          </div>

          {isLoading ? (
            <div className="flex justify-center items-center h-full">
              <IonSpinner name="crescent" />
            </div>
          ) : (
            <ResultGroup
              selectedFoodSet={selectedFoodSet}
              options={suggestionOptions?.mealOptions ?? []}
              onAdd={onAdd}
            />
          )}

          {/* <Divider />

          <ResultGroup options={previousSearches} />

          <Divider />

          <PopularChoices options={popularChoices} /> */}
        </PageContainer>
      </IonModal>
    </>
  );
};

export default AddFoodSearchBar;
